import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'reactstrap';
import { v1 as uuidv1 } from 'uuid';
import useStyles from './styles';


const PlotWrapperTooltip = ({ tooltipText }) => {
  const [id] = useState(`tooltip-${uuidv1()}`);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const classes = useStyles();

  return (
    <React.Fragment>
      <span className={classes.tooltip} href="#" id={id}>?</span>
      <Tooltip placement="right" isOpen={tooltipOpen} target={id} toggle={toggle}>
        {tooltipText}
      </Tooltip>
    </React.Fragment>
  );

};


PlotWrapperTooltip.propTypes = {
  tooltipText: PropTypes.string.isRequired,
};

export default PlotWrapperTooltip;
